const Regex = {
    /**
     * Examples:
     * 1. https://www.instagram.com/johndoe
     */
    INSTAGRAM_URL: /^(https?:\/\/)?(www\.)?instagram\.com\/[a-zA-Z0-9_]+\/?$/,
    /**
     * Examples:
     * 1. `https://www.facebook.com/profile.php?id=123456789`
     * 2. `http://www.facebook.com/profile.php?id=987654321`
     * 3. `https://www.facebook.com/johndoe`
     * 4. `http://www.facebook.com/jane.doe`
     * 5. `https://www.facebook.com/john.doe.12345`
     */
    FACEBOOK_URL: /^(https?:\/\/)?(www\.)?facebook\.com\/(?:profile\.php\?id=\d+|[a-zA-Z0-9.-]+)\/?$/,
    /**
     * Examples:
     * 1. https://www.linkedin.com/in/johndoe
     */
    LINKEDIN_URL: /^(https?:\/\/)?(www\.)?linkedin\.com\/in\/[a-zA-Z0-9-]+\/?$/,
    /**
     * Examples:
     * 1. https://www.mon-site.com/johndoe
     * 2. http://mon-site.com/johndoe
     * 3. mon-site.com/johndoe/
     * 4. subdomain.mon-site.com/johndoe
     */
    URL_REGEX: /^(https?:\/\/)?(www\.)?([a-zA-Z0-9-]+\.[a-zA-Z]{2,})(\/[^\s]*)?$/gim,
    EMAIL_REGEX: /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))\s*$/,
    PASSWORD_REGEX: /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@$!%*?&])[A-Za-z\d@$!%*?&]{8,}$/,
    URL_REGEX_WITHOUT_PROTOCOL: /^[\w.-]+(?:\.[\w\.-]+)+[\w\-\._%~:/?#[\]@!\$&'\(\)\*\+,;=.]+$/,
};

export default Regex;
